<template>
  <div id="devmgerji">
    <el-row>
      <el-button v-if="canCreate" type="primary" icon="el-icon-plus" @click="dialogVisible_adddevice1=true">添加子账户</el-button>
      <el-button type="success" icon="el-icon-refresh" @click="reflash_devlist">刷新</el-button>
    </el-row>
    <el-table :data="tableData" style="width: 1420px" highlight-current-row border>
      <el-table-column type="index" width="100" label="编号 "></el-table-column>
      <el-table-column prop="user_name" label="子账户名字 " width="200"></el-table-column>
      <el-table-column prop="user_level" label="子账户等级 " width="100"></el-table-column>
   <!--   <el-table-column prop="count" label="设备个数 " width="100"></el-table-column> -->
      <el-table-column prop="nickname" label="昵称" width="200"></el-table-column>
      <el-table-column prop="ctime" label="时间 " width="200"></el-table-column>
      <el-table-column label="操作[Operation]" width="400" align="center">
        <template slot-scope="scope">
          <el-badge class="item">
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click.native.prevent="EditRow(scope.$index, tableData)"
              size="small"
              plain
            >编辑</el-button>
          </el-badge>

          <el-badge class="item">
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click.native.prevent="Edittg(scope.$index, tableData)"
              size="small"
              plain
            >改昵称</el-button>
          </el-badge>

          <el-badge
            :value="tableData[scope.$index].shenhecount"
            class="item"
            :max="10"
            type="primary"
          >
           <!-- <el-button
              type="warning"
              icon="el-icon-edit"
              @click.native.prevent="refileRow(scope.$index, tableData)"
              size="small"
              plain
            >审核文件</el-button>-->
          </el-badge>
          <el-badge class="item">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click.native.prevent="goDeleteRow(scope.$index, tableData)"
              size="small"
              plain
            >删除</el-button>
          </el-badge>
          <el-badge class="item">
            <el-button
              type="danger"
              icon="el-icon-refresh"
              @click.native.prevent="goTokenRow(scope.$index, tableData)"
              size="small"
              plain
            >状态测试</el-button>
          </el-badge>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="编辑设备"
      :visible.sync="dialogVisible_adddevice2"
      :before-close="handleClose_adddevice2"
      width="800px"
    >
      <template>
         <span>子用户名：{{ziusername}}</span>
         <el-divider></el-divider>
        <el-transfer
          v-model="valueT"
          width="800px"
          filterable
          :titles="['所有设备', '选中的']"
          :button-texts="['到左边', '到右边']"
          :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}'
            }"
          :data="Tdata"
        >
          <!--el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button>
          <el-button class="transfer-footer" slot="right-footer" size="small">操作</el-button-->
        </el-transfer>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_save_ziuserdev">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添子账户"
      :visible.sync="dialogVisible_adddevice1"
      width="400px"
      :before-close="handleClose_adddevice1"
    >


      <el-row>
        <el-tooltip class="item" effect="dark" content="建议使用该用户的手机号码" placement="top-start">
          <el-input style="width: 300px;" placeholder="子账户用户名" v-model="ziusername"></el-input>
        </el-tooltip>
      </el-row>
      <el-row>
        <el-tooltip class="item" effect="dark" content="密码为数字或者是英文字符" placement="top-start">
          <el-input
            style="width: 300px; margin-top: 10px;"
            placeholder="子账户密码"
            v-model="zipasswd"
            show-password
          ></el-input>
        </el-tooltip>
      </el-row>
	  <el-row>
	    <el-tooltip class="item" effect="dark" content="账号备注" placement="top-start">
	      <el-input
	        style="width: 300px; margin-top: 10px;"
	        placeholder="子账户备注信息"
	        v-model="zibeizhu"
	      ></el-input>
	    </el-tooltip>
	  </el-row>
      <el-row>
        <el-tooltip class="item" effect="dark" content="子用户等级不得高于自己等级" placement="top-start">
          <el-input-number
            v-model="userlevel"
            :min="1"
            :max="userlevel"
            style="width: 300px; margin-top: 10px;"
            label="用户等级"
          ></el-input-number>
        </el-tooltip>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_addziuserKey">添加子账户</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="审核文件"
      :visible.sync="dialogVisible_adddevice3"
      :before-close="handleClose_adddevice3"
      width="900px"
    >
      <div style="padding:10px 0;">
        <a-player
          :autoplay="autoplay"
          :music="songList"
          v-if="flag"
          mutex
          listmaxheight="10px"
          ref="player"
        >
        </a-player>
      </div>
      <el-table :data="tableDatafilelist" highlight-current-row border style="width: 800px">
        <el-table-column type="index" width="100" label="编号"></el-table-column>
        <el-table-column prop="filename" label="文件名" width="300"></el-table-column>
        <el-table-column prop="filesize" label="文件大小" width="100"></el-table-column>
        <el-table-column label="试听" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="playurl(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >播放</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="isroot" label="审核" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              active-value="1"
              inactive-value="0"
              v-model="tableDatafilelist[scope.$index].enable"
              @change="abletask( scope.$index, tableDatafilelist)"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import VueAplayerfuck from "vue-aplayer";
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
export default {
  components: {
    //别忘了引入组件
    "a-player": VueAplayerfuck
  },
  data() {
    return {
      options: [],
      nodeid: "",
      zipasswd: "",
	    zibeizhu:"",
      ziusername: "",
      group_name: "",
      tableData: [],
      dialogVisible_adddevice1: false,
      dialogVisible_adddevice2: false,
      dialogVisible_adddevice3: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      valueT: [],
      valueFS: [],
      dev_info_zS: [],
      Tdata: [],
      fornodeid: -1,
      forgid: -1,
      userlevel: 1,
      autoplay: false,
      isroot: false,
      fileList: [],
      tableDatafilelist: [],
      songList: [],
      flag: false,
      mask : "",
      canCreate : false
    };
  },
  created() {
    this.userlevel = sessionStorage.getItem("user_level") - 1;
    this.reflash_devlist();
    this.mask = sessionStorage.getItem("mask");
    console.log("===================>");
    console.log(this.mask);
    console.log("===================>");
    if(this.mask.charAt(0) == '1'){
    	this.canCreate = true;
    }
  },
  methods: {
    goTokenRow(index, rows){
      let data = new FormData();
      data.append("username",rows[index].user_name);
      data.append("passwd", rows[index].user_pass);
      axios.post("/user/gtoken", data ).then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "测试成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "测试失败",
                showClose: false
              });
            }
          }.bind(this)
        ).catch(function(res) {
          console.log(res);
        });
    },

    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    open5() {
      this.$alert(this.save_backdata, "配置详情", {
        dangerouslyUseHTMLString: false
      });
    },
    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    playurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
    func_addziuserKey() {
      if (this.ziusername.trim() == "" || this.ziusername.length < 7) {
        this.$notify.success({
          title: "Info",
          message: "用户名需要11位数字手机号码",
          showClose: true
        });
        return;
      }

      if (this.zipasswd == "" || this.zipasswd.length < 7) {
        this.$notify.success({
          title: "Info",
          message: "密码必须为7位以上 英文或数字混写",
          showClose: true
        });
        return;
      }
      console.log(  "==>"+this.userlevel+"=>"+sessionStorage.getItem("user_level")+"==>"+  sessionStorage.getItem("user_type")  );
      if (
        this.userlevel >= 1 &&
        this.userlevel < sessionStorage.getItem("user_level")
      ) {

		 if(this.zibeizhu.trim() == ""){
			this.zibeizhu="NOTHING";
		 }
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        data.append("zipasswd", this.zipasswd);
        data.append("ziusername", this.ziusername);
        data.append("beizhu",  this.zibeizhu );
        data.append("level", this.userlevel);
        data.append("nickname", "nickname");
        data.append("mask", "00000000000000000000000000000000000000000000");
        /*
        data:{
        	id			: this.userid.toString(),
        	token		: this.token,
        	ziusername	: this.newusername_value.trim(),
        	zipasswd	: this.newpasswd2_value.trim(),
        	ziuserbz	: this.newuserbz_value.trim(),
        	mask:"00000000000000000000000000000000000000000000",
        	nickname:"nickname"
        },*/
        axios
          .post("/user/fnckukei/addziuser", data)
          .then(
            function(res) {
              if (res.data.res) {
                this.reflash_devlist();
              } else {
                this.$notify.success({
                  title: "Info",
                  message: "添加出错 可能用户名已经被占用",
                  showClose: false
                });
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });
      } else {
        this.$notify.success({
          title: "Info",
          message: "用户等级不正确",
          showClose: true
        });
      }
      this.dialogVisible_adddevice1 = false;
    },

    func_save_ziuserdev() {

      var pus_idstr = "";
      var dis_idstr = "";
      var cpus = 0;
      var cdis = 0;
      var tmpselect = [];
      var pus_cols = []; //增加的集合
      var dis_cols = []; //减少的结合
      var pus_idcols = [];
      var dis_idcols = [];
      var select_sns = [];
      var pre_sns = [];
      console.log(this.Tdata);
      console.log(this.valueT);
      console.log(this.valueT.length);
      if (this.valueT.length == 0) {
        return;
      }

      this.valueFS.forEach((item,index,arr)=>{
      		tmpselect.push(item);
      });
      this.valueT.forEach((item,index,arr)=>{
      		select_sns.push(item);
      });
      tmpselect.forEach((its,inds,arr) => {
      	if( select_sns.includes(its) == false ){
      		dis_cols.push(its);
      		console.log("dis_cols ->" ,its  );
      	}
      });
      console.log("dis_cols-->");
      console.log(dis_cols);
      select_sns.forEach((its,inds,arr) => {
      	if( tmpselect.includes(its) == false ){
      		pus_cols.push(its);
      		console.log("pus_cols ->" ,  its );
      	}
      });
      console.log("pus_cols->");
      console.log(pus_cols);

      this.dev_info_zS.forEach((item,index,arr)=>{
      	 if( dis_cols.includes(item.device_seed) == true ){
      		 dis_idcols.push(item.id);
      	 }
      });
      console.log("-----------------dis_idcols------------------");
      console.log(dis_idcols);
      this.Tdata.forEach((item,index,arr)=>{
      	 if( pus_cols.includes(item.device_seed) == true ){
      		 pus_idcols.push(item.id);
      	 }
      });
      console.log("-----------------pus_idcols------------------");
      console.log(pus_idcols);

      // this.Tdata.forEach((item,index,arr)=>{
      // 	pre_sns.push(item.device_seed);
      // });
      // select_sns.forEach((its,inds,arr) => {
      // 	if( pre_sns.includes(its) == false ){
      // 		pus_cols.push(its);
      // 		console.log("pus_cols ->" ,  its );
      // 	}
      // });
      // pre_sns.forEach((its,inds,arr) => {
      // 	if( select_sns.includes(its) == false ){
      // 		dis_cols.push(its);
      // 		console.log("dis_cols ->" ,its  );
      // 	}
      // });
      // this.nowgrpitemdlist.forEach((item,index,arr)=>{
      // 	 if( dis_cols.includes(item.device_seed) == true ){
      // 		 dis_idcols.push(item.id);
      // 	 }
      // });
      if(dis_idcols.length > 0 ){
      	dis_idstr  = dis_idcols.join("|");
      }else{
      	dis_idstr = "null";
      }
      if(pus_idcols.length > 0 ){
      	pus_idstr  = pus_idcols.join("|");
      }else{
      	pus_idstr = "null";
      }
      console.log("pus_idstr:",pus_idstr);
      console.log("dis_idstr:",dis_idstr);

      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("gid", this.forgid);
      data.append("pus_idstr", pus_idstr);
      data.append("dis_idstr", dis_idstr);
      axios
        .post("/user/fnckukei/changezidevices", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
              this.dialogVisible_adddevice = false;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
       return;

    },
    func_addgoup() {},

    func_adddevic() {
      this.dialogVisible_adddevice2 = true;
    },

    deleteRow(index, rows) {

      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("zid", rows[index].id);
      axios.post("/user/fnckukei/delziuser", data ).then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        ).catch(function(res) {
          console.log(res);
        });
    },
    EditRow(index, rows) {
      this.dialogVisible_adddevice2 = true;
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("zid", rows[index].id);
      data.append("ztoken", rows[index].token);
      this.ziusername = rows[index].user_name;
      axios
        .post("/user/fnckukei/info_edit_listziuser", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.Tdata = res.data.dev_info;
              this.valueT = res.data.dev_info_S;
              this.valueFS= res.data.dev_info_S;
              this.dev_info_zS = res.data.dev_info_zS;
              this.forgid = rows[index].id;
              this.dialogVisible_adddevice = true;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常1",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    Edittg(index, rows) {
      let ziuserid =rows[index].ziuserid;
        this.$prompt("New 备注:", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: "格式不正确"
        })
        .then(({ value }) => {
          if (value.length <5 ) {
            this.$message({
              type: "info",
              message: "输入备注不正确 请认真输入"
            });
            return;
          }
          let data = new FormData();
          data.append("id", rows[index].id );
          data.append("token", rows[index].token);
          data.append("nickname", value );
          axios
            .post("/user/fnckukei/newnickname", data )
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });
                  rows.splice(index, 1);
                  this.reflash_devlist();
                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    refileRow(index, rows) {
      this.dialogVisible_adddevice3 = true;

      axios
        .get("/Get_file_Listbyid.php", {
          params: {
            username: rows[index].user_name,
            ziuserid: rows[index].ziuserid,
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    handleClose_adddevice1() {
      this.dialogVisible_adddevice1 = false;
    },
    handleClose_adddevice2() {
      this.dialogVisible_adddevice2 = false;
    },
    handleClose_adddevice3() {
      this.dialogVisible_adddevice3 = false;
      this.reflash_devlist();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflash_devlist: function() {
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios.post("/user/fnckukei/listziuser", data ).then(
          function(res) {
            if (res.data.res) {
               console.log(res);
               if(res.data.res == true){
                  this.tableData = res.data.results;
                  console.log(res.data);
               }else{
                 this.newusererroinfo = "添加异常";
               }
            }
          }.bind(this)
      ).catch(function(res) {
        console.log(res);
      });
      // axios
      //   .get("/get_ziuser_info_fuckyangmei.php", {
      //     params: {
      //       username: sessionStorage.getItem("username"),
      //       passwd: sessionStorage.getItem("passwd")
      //     }
      //   })
      //   .then(
      //     function(res) {
      //       if (res.data.res) {
      //         this.tableData = res.data.dataJson;
      //         this.$forceUpdate();
      //       }
      //     }.bind(this)
      //   )
      //   .catch(function(res) {
      //     console.log(res);
      //   });
    }
  }
};
</script>

<style  scoped>
.el-select .el-input {
  width: 200px;
}
.el-transfer {
  text-align: left;
}

#devmgerji {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px auto;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.item {
  margin-top: 10px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/erjizhanghu.vue